module.exports = __webpack_public_path__ + "img/laposte-background.0d4f691e.webp";